import { trackingConstants } from '@frontend/sports/tracking/feature';

export class OddsPreferenceTracking {
    // SpeedTooltip: show
    static SpeedTooltipAndShow = { [trackingConstants.PAGE_NAME]: 'M2_slip_action_SpeedTooltip_show' };
    // SpeedTooltip: click
    static SpeedTooltipAndClick = { [trackingConstants.PAGE_NAME]: 'M2_slip_action_SpeedTooltip_click' };
    // SpeedTooltip: Track when user 'Accept any changes' button in modal popup
    static SpeedTooltipAndAnyOdds = { [trackingConstants.PAGE_NAME]: 'M2_slip_action_SpeedTooltip/AOdds' };
}
